import { Component, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService, AppInformationService, GenesisUnitOfWork } from 'app/core/core.module';
import { Photo } from 'app/core/model/photo';
import { InputDialogComponent } from 'app/shared/input-dialog/input-dialog.component';
import { SharedModule } from 'app/shared/shared.module';
import { BsModalService } from 'ngx-bootstrap/modal';
import { confirm } from 'devextreme/ui/dialog';
import { DeliveryFlyoutComponent } from '../../scheduling/delivery-flyout/delivery-flyout.component';
import { Delivery } from 'app/core/model/delivery';

@Component({
    selector: 'app-pictures-overview',
    templateUrl: './pictures-overview.component.html',
    styleUrls: ['./pictures-overview.component.scss'],
    standalone: false
})
export class PicturesOverviewComponent {
    photos: Photo[];

    onExporting = SharedModule.onExporting;
    onOptionChangedShared = SharedModule.onOptionChanged;

    constructor(private uow: GenesisUnitOfWork, private router: Router, private modalService: BsModalService, private auth: AuthService, private appInfo: AppInformationService) {}

    async ngOnInit() {
        await this.getData();
    }

    async getData() {
        this.photos = await this.uow.getPhotos(null, null, 'order, packingSlip, purchaseOrder, delivery');
    }

    async open(photo: Photo) {
        if (!photo) return;

        switch (photo.type) {
            case 'Order':
                this.router.navigate([`/sales-orders/${photo.linkId}`]);
                break;
            case 'Pack Slip':
                this.router.navigate([`/packingslips/${photo.linkId}`]);
                break;
            case 'Purchase Order':
                this.router.navigate([`/purchase-orders/${photo.linkId}`]);
                break;
            case 'Delivery':
                const delivery = (await this.uow.deliveries.byId(photo.delivery.id, 'deliveryStacks.orderLineDetail.orderLine.order.dealer')) as Delivery;
                const modalRef = this.modalService.show(DeliveryFlyoutComponent, {
                    class: 'modal-lg',
                    ignoreBackdropClick: true,
                    keyboard: false,
                    initialState: {
                        readOnly: true,
                        delivery: delivery,
                        showAsDialog: true,
                        deliveryStacks: delivery.deliveryStacks,
                    },
                });
                modalRef.content.result.subscribe(async (result) => {
                    modalRef.hide();
                });
                break;
        }
    }

    openFile(photo: Photo) {
        if (!photo) return;

        window.open(photo.filename, '_blank');
    }

    onToolbarPreparing(e) {
        e.toolbarOptions.items.unshift(
            {
                location: 'before',
                template: 'toolbarButtons',
            },
            {
                widget: 'dxButton',
                options: {
                    icon: 'revert',
                    elementAttr: { title: 'Reset Filters' },
                    onClick: () => {
                        e.component.clearFilter();
                    },
                },
                location: 'after',
            },
            {
                widget: 'dxButton',
                options: {
                    icon: 'refresh',
                    elementAttr: { title: 'Reset Grid Layout' },
                    onClick: () => {
                        e.component.state({});
                    },
                },
                location: 'after',
            }
        );
    }

    async rename(photo: Photo) {
        const modalRef = this.modalService.show(InputDialogComponent, {
            class: 'modal-sm',
            ignoreBackdropClick: true,
            keyboard: false,
            initialState: {
                dialogHeader: 'Edit Name',
                mode: 'text',
                dialogValue: photo.name,
            },
        });

        modalRef.content.result.subscribe(async (result) => {
            if (result.result && !!result.value) {
                photo.name = result.value;
                await this.uow.commit();
            }
            modalRef.hide();
        });
    }

    async addNote(photo: Photo) {
        const modalRef = this.modalService.show(InputDialogComponent, {
            class: 'modal-sm',
            ignoreBackdropClick: true,
            keyboard: false,
            initialState: {
                dialogHeader: 'Add Note',
                mode: 'textarea',
                dialogValue: photo.notes,
            },
        });

        modalRef.content.result.subscribe(async (result) => {
            if (result.result && !!result.value) {
                photo.notes = result.value;
                await this.uow.commit();
            }
            modalRef.hide();
        });
    }

    async delete(selection: any) {
        const success = await confirm(`Are you sure you want to DELETE this picture?`, `${this.appInfo.settings.company}`);
        if (!success) return;
        this.appInfo.pleaseWaitShow();
        selection.forEach((row) => {
            row.deleted = new Date();
            row.deletedBy = this.auth.currentUser.userName;
        });
        await this.uow.commit();
        await this.getData();
        this.appInfo.pleaseWaitHide();
    }
}
